<template>
  <PageHeader :showBreadcrumb="true" />
  <p>
    Welcome to the Provider Network Adequacy page. From this page, you can upload the Annual Network Adequacy Filings (generally due the end of May each year), Provider File Updates (due February and October each year), and Provider Terminations (due monthly). Please click in the section to upload files.
  </p>
  <p>
    More information can be found: <a href="https://www.health.state.mn.us/facilities/insurance/managedcare/networkadequacy/filingreqprovidernetwork.html">Network Adequacy Filing Requirements</a>
  </p>
  <p>
    If you have questions, please contact <a href="mailto:health.managedcare@state.mn.us">health.managedcare@state.mn.us</a>.
  </p>
  <hr/>
  <div class="container p-3 text-center">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">Annual Network Review for Upcoming Plan Year</h2>
          <PvButton size="lg" class="me-2" rounded raised label="Go to Annual Network Review" severity="primary" @click="router.push('/NetworkAdequacy/AnnualNetworkReview');"/>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">Provider Terminations</h2>
          <PvButton size="lg" class="me-2" rounded raised label="Go to Provider Terminations" severity="primary" @click="router.push('/NetworkAdequacy/ProviderTerminations');"/>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">Provider File Updates</h2>
          <PvButton size="lg" class="me-2" rounded raised label="Go to Provider File Updates" severity="primary" @click="router.push('/NetworkAdequacy/ProviderFileUpdates');"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
import router from "@/router/index.js";
</script>

<style scoped>
.portal-box {
  height: 200px;
}
.tx-col {
  height: 75%;
}
</style>